module.exports = __webpack_public_path__ + "img/braip.09c6bae9.png";